var map = {
	"./completelist/Main": [
		3351,
		86,
		110,
		351
	],
	"./flappy/Main": [
		308,
		86,
		110,
		308
	],
	"./minigolf/Main": [
		2175,
		86,
		110,
		175
	],
	"./quizrush/Main": [
		1650,
		86,
		110,
		650
	],
	"./runner/Main": [
		9838,
		86,
		110,
		838
	],
	"./sidescroller/Main": [
		9447,
		86,
		110,
		447
	],
	"./snake/Main": [
		8192,
		86,
		110,
		192
	],
	"./stacker/Main": [
		7539,
		86,
		110,
		539
	],
	"./verticalclimber/Main": [
		5006,
		86,
		110,
		6
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9468;
module.exports = webpackAsyncContext;